angular.module('powerOfAttorney')
    .component('powerOfAttorneyList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/power-of-attorney/list.html',
        controller: function ($scope, $stateParams, PowerOfAttorney, PowerOfAttorneyService, Principal, PowerOfAttorneyConst) {
            this.PowerOfAttorneyService = PowerOfAttorneyService
            this.reset = () => this.filters = {filter: this.filters.filter}

            this.$onInit = () => {
                this.canOpenSettings = Principal.hasAnyAuthority(["ROLE_POWER_OF_ATTORNEY_SETTINGS"])
            }

            this.refresh = () => {
                PowerOfAttorney.table($stateParams).$promise.then(page => this.page = page)
                PowerOfAttorney.tableStatistics($stateParams).$promise.then(statistics => this.statistics = statistics)
            }

            $scope.$on(PowerOfAttorneyConst.eventUpdate, () => this.refresh())
            $scope.$on(PowerOfAttorneyConst.eventDelete, () => this.refresh())
        }
    })
